import { Sparkles } from "lucide-react";
import { SERVICES } from "@/lib/site";

// One slow editorial ribbon — items render once per loop half.
export default function Marquee() {
  return (
    <section aria-label="Our services" className="overflow-hidden border-y border-white/10 bg-panel/50 py-6">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} aria-hidden={half === 1} className="flex w-max items-center">
            {SERVICES.map((s) => (
              <span key={`${half}-${s.slug}`} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-mono text-sm font-medium uppercase tracking-[0.3em] text-mist">
                  {s.name}
                </span>
                <Sparkles className="h-4 w-4 shrink-0 text-ember" aria-hidden />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
